"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FullScreenComponent = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _screenfull = _interopRequireDefault(require("screenfull"));

var FullScreenComponent = function FullScreenComponent(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      onError = _ref.onError;
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    _screenfull["default"].onchange(function () {
      if (onChange) {
        onChange();
      }
    });

    _screenfull["default"].on('error', function (event) {
      if (onError) {
        onError();
      }
    });
  }, []);
  return children({
    ref: ref,
    isEnabled: _screenfull["default"].isEnabled,
    onToggle: function onToggle() {
      _screenfull["default"].toggle(ref.current);
    },
    onRequest: function onRequest() {
      _screenfull["default"].request(ref.current);
    },
    onExit: function onExit() {
      _screenfull["default"].exit(ref.current);
    }
  });
};

exports.FullScreenComponent = FullScreenComponent;
FullScreenComponent.propTypes = {
  children: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func
};

var _default = /*#__PURE__*/(0, _react.memo)(FullScreenComponent);

exports["default"] = _default;